import { render, staticRenderFns } from "./ReportInvoice.vue?vue&type=template&id=6b2e838a&"
import script from "./ReportInvoice.vue?vue&type=script&lang=js&"
export * from "./ReportInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports